<iframe
  #iframe
  [src]="iframeUrl()"
  class="w-full h-full border-none"
  title="Consent Form"
></iframe>
